export default {
      id: "planner-trash-usage",
      viewBox: "0 0 14 16",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#planner-trash",
      toString: function () {
        return this.url;
      }
    }